import React, { useState } from 'react';

// Local lightweight Slider implementation (replaces 'react-player-controls')
// Props kept compatible with the project usage
type Direction = 'HORIZONTAL' | 'VERTICAL';

export const Slider = ({
  isEnabled,
  direction = 'HORIZONTAL',
  value,
  onChange,
  ...props
}: {
  isEnabled: boolean;
  direction?: Direction;
  value: number;
  onChange: (value: number) => void;
}) => {
  const [hovered, setHovered] = useState(false);

  // clamp 0..1 like previous component
  const val = Math.max(0, Math.min(1, value ?? 0));
  const percent = val * 100;
  const fillColor = hovered ? '#1db954' : '#ffffff';

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const next = Number(e.target.value);
    if (typeof onChange === 'function') onChange(next);
  };

  // For vertical, rotate using CSS. Keep classNames to preserve styling.
  const isVertical = direction === 'VERTICAL';

  return (
    <div
      className='volume-sider-container'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(isVertical ? { height: 80 } : { width: '100%' }),
      }}
    >
      <div
        className='volume-sider'
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          cursor: isEnabled ? 'pointer' : 'not-allowed',
          opacity: isEnabled ? 1 : 0.5,
          transform: isVertical ? 'rotate(-90deg)' : undefined,
          width: isVertical ? 80 : '100%',
        }}
        {...props}
      >
        <input
          type='range'
          min={0}
          max={1}
          step={0.01}
          value={val}
          onChange={isEnabled ? handleChange : undefined}
          aria-disabled={!isEnabled}
          className='position-sider'
          style={{
            width: '100%',
            background: `linear-gradient(to right, ${fillColor} ${percent}%, #4d4d4d ${percent}%)`,
          }}
        />
      </div>
    </div>
  );
};

export default Slider;
